"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STYLE_TYPE = exports.MARKING_TYPE = void 0;
var STYLE_TYPE = exports.STYLE_TYPE = /*#__PURE__*/function (STYLE_TYPE) {
  STYLE_TYPE["outlined"] = "outlined";
  STYLE_TYPE["underlined"] = "underlined";
  STYLE_TYPE["underlinedFloatingLabel"] = "underlinedFloatingLabel";
  return STYLE_TYPE;
}(STYLE_TYPE || {});
var MARKING_TYPE = exports.MARKING_TYPE = /*#__PURE__*/function (MARKING_TYPE) {
  MARKING_TYPE["none"] = "none";
  MARKING_TYPE["required"] = "required";
  MARKING_TYPE["optional"] = "optional";
  return MARKING_TYPE;
}(MARKING_TYPE || {});
//# sourceMappingURL=common.js.map